import router from '@/router'
import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'

router.addRoute({
  path: '/funding/explore/:productType/:opportunityId',
  name: 'funding-explore-deal',
  components: {
    default: () => import('@product/components/OpportunityView.vue')
  },
  meta: {
    permissions: {
      roles: ['user'],
      redirectTo: {
        name: 'login'
      }
    },
    disablePageViewTracking: true
  },
  beforeEnter: allowOnlyWithCompletedJourney()
})

export default {
  path: 'explore',
  name: 'funding-explore',
  components: () => import('./explore.vue'),
  meta: {
    permissions: {
      roles: ['user'],
      redirectTo: {
        name: 'login'
      }
    }
  },
  beforeEnter: allowOnlyWithCompletedJourney()
}
